// cards
const $1bc98ea51c43dc5c$export$1ae16fa4a9e4bff5 = document.getElementById("test-card");
const $1bc98ea51c43dc5c$export$ef0aad052826c4ef = document.getElementById("results-card");
const $1bc98ea51c43dc5c$export$d32bf212a3195752 = document.getElementById("options-card");
const $1bc98ea51c43dc5c$export$50b5fc66fb330b94 = document.getElementById("test-text");
const $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53 = document.getElementById("test-input");
const $1bc98ea51c43dc5c$export$91d0b2eeabd10528 = document.getElementById("test-input-container");
const $1bc98ea51c43dc5c$export$7ff0b578ca874c9f = document.getElementById("test-timer-text");
const $1bc98ea51c43dc5c$export$1068e950eff93f20 = document.getElementById("current-word-indicator");
const $1bc98ea51c43dc5c$export$5f151fe9c0b9aeaa = document.getElementById("wpm-text");
const $1bc98ea51c43dc5c$export$6ffccc7bffd3afee = document.getElementById("test-type-text");
const $1bc98ea51c43dc5c$export$a70d6830a0f603df = document.getElementById("words-text");
const $1bc98ea51c43dc5c$export$bb81a194acec0726 = document.getElementById("chars-text");
const $1bc98ea51c43dc5c$export$7571f381949cae11 = document.getElementById("time-text");
const $1bc98ea51c43dc5c$export$fc31c273664452ca = document.getElementById("options-test-type-words-button");
const $1bc98ea51c43dc5c$export$f01f3933c59ae7c1 = document.getElementById("options-words-10-button");
const $1bc98ea51c43dc5c$export$a159b208d2279103 = document.getElementById("options-words-25-button");
const $1bc98ea51c43dc5c$export$8137a8da3720eff5 = document.getElementById("options-words-50-button");
const $1bc98ea51c43dc5c$export$daf244641a671a33 = document.getElementById("options-words-100-button");
const $1bc98ea51c43dc5c$export$5e12fee2da7f30a = document.getElementById("options-words-200-button");
const $1bc98ea51c43dc5c$export$d3fad732915680bc = document.getElementById("options-current-word-indicator-animations-on-button");
const $1bc98ea51c43dc5c$export$41b57f6f5001a03 = document.getElementById("options-current-word-indicator-animations-off-button");
const $1bc98ea51c43dc5c$export$9ab3e8ebbd54dd89 = document.getElementById("restart-test-button");
const $1bc98ea51c43dc5c$export$e8cb2ff66da92add = document.getElementById("options-button");
const $1bc98ea51c43dc5c$export$f427401ec6aabe5d = document.getElementById("options-done-button");


const $0d987d677917272a$export$f84bd70098573c5c = {
    testInfo: {
        type: "words",
        words: 10
    },
    currentWordIndicatorAnimations: "on"
};


const $a1848bf1cadb8d5f$export$44487a86467333c3 = ()=>{
    const storedConfig = localStorage.getItem("config");
    let config;
    if (storedConfig) config = JSON.parse(storedConfig);
    else {
        localStorage.setItem("config", JSON.stringify((0, $0d987d677917272a$export$f84bd70098573c5c)));
        config = (0, $0d987d677917272a$export$f84bd70098573c5c);
    }
    // fill empty properties
    return $a1848bf1cadb8d5f$export$6969335ea1e4e77c(structuredClone((0, $0d987d677917272a$export$f84bd70098573c5c)), config);
};
const $a1848bf1cadb8d5f$export$6969335ea1e4e77c = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === "object";
    if (!isObject(target) || !isObject(source)) return source;
    Object.keys(source).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) target[key] = sourceValue;
        else if (isObject(targetValue) && isObject(sourceValue)) target[key] = $a1848bf1cadb8d5f$export$6969335ea1e4e77c({
            ...targetValue
        }, sourceValue);
        else target[key] = sourceValue;
    });
    return target;
};
const $a1848bf1cadb8d5f$export$940a7873bb071df8 = (newConfig)=>{
    localStorage.setItem("config", JSON.stringify(newConfig));
};



const $78239f00f1dce5ee$export$d533be0028bf978d = ()=>{
    return (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).getAttribute("current-state");
};
const $78239f00f1dce5ee$export$41f3a0a73bb8b261 = (state)=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).setAttribute("current-state", state.toString());
};



let $2b5f46016294fb27$var$previousY = 0;
const $2b5f46016294fb27$export$20cc271121bbde84 = (wordSpanEl)=>{
    const rect = wordSpanEl.getBoundingClientRect();
    const { x: x, y: y, width: w, height: h } = rect;
    const movedDown = y > $2b5f46016294fb27$var$previousY;
    $2b5f46016294fb27$var$previousY = y;
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).style.left = `${x}px`;
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).style.top = `${y}px`;
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).style.width = `${w}px`;
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).style.height = `${h}px`;
    return movedDown;
};
const $2b5f46016294fb27$export$878e62d4407c63a6 = ()=>{
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).classList.replace("block", "hidden");
};
const $2b5f46016294fb27$export$b3353b67a6a0770d = ()=>{
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).classList.replace("hidden", "block");
};
const $2b5f46016294fb27$export$bbc511b76550a421 = ()=>{
    (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).classList.replace("bg-rose-500", "bg-neutral-500");
};




const $586319c84bea0266$export$a6eec20204fcb27f = (cardEl)=>{
    (0, $1bc98ea51c43dc5c$export$1ae16fa4a9e4bff5).classList.replace("block", "hidden");
    (0, $1bc98ea51c43dc5c$export$ef0aad052826c4ef).classList.replace("block", "hidden");
    (0, $1bc98ea51c43dc5c$export$d32bf212a3195752).classList.replace("block", "hidden");
    cardEl.classList.add("animate-up-bouncy");
    cardEl.classList.replace("hidden", "block");
    return new Promise((resolve)=>{
        cardEl.offsetHeight; // forces a reflow
        setTimeout(()=>{
            resolve();
        }, 500);
    });
};




const $2769bd2ce2c1e2a1$export$3203edd9e5edd663 = (time)=>{
    const minutes = Math.floor(time / 1000 / 60);
    const seconds = Math.floor(time / 1000 % 60);
    const milliseconds = Math.floor(time % 1000 / 10);
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds.toString().padStart(2, "0")}`;
};
const $2769bd2ce2c1e2a1$export$df57a2efc33a11fd = (time)=>{
    return (time / 1000).toFixed(2);
};



const $a2db21f4cb59e11c$export$3e41cefc7a4774f7 = (test)=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).setAttribute("test-info", JSON.stringify(test));
};
const $a2db21f4cb59e11c$export$54627621f93bd125 = ()=>{
    return JSON.parse((0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).getAttribute("test-info"));
};
const $a2db21f4cb59e11c$export$e710b52d623a71ad = ()=>{
    return parseInt((0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).getAttribute("word-index"));
};
const $a2db21f4cb59e11c$export$1f1f6014d63e98f6 = (val)=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).setAttribute("word-index", val.toString());
};
const $a2db21f4cb59e11c$export$a3d08e7102597923 = ()=>{
    return parseInt((0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).getAttribute("chars-typed"));
};
const $a2db21f4cb59e11c$export$e6bc8450ad81a778 = (val)=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).setAttribute("chars-typed", val.toString());
};
const $a2db21f4cb59e11c$export$bd6cde7132e04046 = (time)=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).setAttribute("start-time", time.toString());
};
const $a2db21f4cb59e11c$export$77120b8fb6c6fdaa = ()=>{
    return parseInt((0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).getAttribute("start-time"));
};
const $a2db21f4cb59e11c$export$feb6a38a53ca6afd = (time)=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).setAttribute("end-time", time.toString());
};
const $a2db21f4cb59e11c$export$26f29c9ca2c6ad44 = ()=>{
    return parseInt((0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).getAttribute("end-time"));
};




let $36749efec06aa61f$var$intervalId;
const $36749efec06aa61f$export$5985f5b4428bec55 = ()=>{
    let time = 0; // milliseconds
    $36749efec06aa61f$var$intervalId = setInterval(()=>{
        time += 10;
        (0, $1bc98ea51c43dc5c$export$7ff0b578ca874c9f).textContent = (0, $2769bd2ce2c1e2a1$export$3203edd9e5edd663)(time) + "s";
    }, 10);
};
const $36749efec06aa61f$export$4d41f7386211339a = ()=>{
    clearInterval($36749efec06aa61f$var$intervalId);
};
const $36749efec06aa61f$export$148d61ea341bbff7 = ()=>{
    (0, $1bc98ea51c43dc5c$export$7ff0b578ca874c9f).textContent = "00:00.00s";
};
const $36749efec06aa61f$export$1c7b91b26fff0bae = ()=>{
    (0, $1bc98ea51c43dc5c$export$7ff0b578ca874c9f).style.transition = "none"; // no transition
    (0, $1bc98ea51c43dc5c$export$7ff0b578ca874c9f).style.opacity = "0";
};
const $36749efec06aa61f$export$18e1d7a642e396fa = ()=>{
    (0, $1bc98ea51c43dc5c$export$7ff0b578ca874c9f).style.transition = "opacity 1s"; // 2-second transition
    (0, $1bc98ea51c43dc5c$export$7ff0b578ca874c9f).style.opacity = "1";
};


const $3948815c2aaf0381$export$1087492337de9603 = ()=>{
    (0, $a2db21f4cb59e11c$export$feb6a38a53ca6afd)(Date.now());
    (0, $78239f00f1dce5ee$export$41f3a0a73bb8b261)("finished");
    (0, $2b5f46016294fb27$export$878e62d4407c63a6)();
    (0, $586319c84bea0266$export$a6eec20204fcb27f)((0, $1bc98ea51c43dc5c$export$ef0aad052826c4ef));
    (0, $36749efec06aa61f$export$4d41f7386211339a)();
    (0, $36749efec06aa61f$export$1c7b91b26fff0bae)();
    const testInfo = (0, $a2db21f4cb59e11c$export$54627621f93bd125)();
    const charsTyped = (0, $a2db21f4cb59e11c$export$a3d08e7102597923)();
    const time = (0, $a2db21f4cb59e11c$export$26f29c9ca2c6ad44)() - (0, $a2db21f4cb59e11c$export$77120b8fb6c6fdaa)();
    const timeAsMinutes = time / 60000;
    const wpm = Math.floor(charsTyped / (timeAsMinutes * 5));
    if (wpm < 1) (0, $1bc98ea51c43dc5c$export$5f151fe9c0b9aeaa).textContent = "< 0 wpm";
    else (0, $1bc98ea51c43dc5c$export$5f151fe9c0b9aeaa).textContent = wpm + " wpm";
    (0, $1bc98ea51c43dc5c$export$6ffccc7bffd3afee).textContent = "words " + testInfo.words;
    (0, $1bc98ea51c43dc5c$export$a70d6830a0f603df).textContent = testInfo.words + " words";
    (0, $1bc98ea51c43dc5c$export$bb81a194acec0726).textContent = charsTyped + " chars";
    (0, $1bc98ea51c43dc5c$export$7571f381949cae11).textContent = (0, $2769bd2ce2c1e2a1$export$df57a2efc33a11fd)(time) + "s";
};



const $f193b2ccc654ef47$export$12d9e5f9858e8e8c = (e)=>{
    // in case already focused
    if ((0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).matches(":focus")) return;
    $f193b2ccc654ef47$export$6699060e52d60aa1(e);
};
const $f193b2ccc654ef47$export$6699060e52d60aa1 = (e)=>{
    (0, $1bc98ea51c43dc5c$export$91d0b2eeabd10528).classList.remove("border-transparent");
    (0, $1bc98ea51c43dc5c$export$91d0b2eeabd10528).style.borderColor = "#0ea5e9";
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).focus();
    e?.preventDefault();
};
const $f193b2ccc654ef47$export$e6a7208b0d9569e1 = ()=>{
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).blur();
    (0, $1bc98ea51c43dc5c$export$91d0b2eeabd10528).style.borderColor = "#00000000";
    (0, $1bc98ea51c43dc5c$export$91d0b2eeabd10528).classList.add("border-transparent");
};



const $48b5dc5f019e67f5$export$a94b587a1cc82520 = (e)=>{
    (0, $1bc98ea51c43dc5c$export$9ab3e8ebbd54dd89).focus();
    e.preventDefault();
};
const $48b5dc5f019e67f5$export$bd1b731c4bf61afb = ()=>{
    (0, $1bc98ea51c43dc5c$export$9ab3e8ebbd54dd89).blur();
};




const $7c44e9d4c9fe16e3$export$7d66fdeae8af3f34 = ()=>{
    $7c44e9d4c9fe16e3$export$68dcec276bb0168();
    $7c44e9d4c9fe16e3$var$listenFocusTestInput();
    $7c44e9d4c9fe16e3$var$listenUnfocusTestInput();
    $7c44e9d4c9fe16e3$var$listenCompleteWord();
    $7c44e9d4c9fe16e3$var$listenCharInput();
    $7c44e9d4c9fe16e3$var$realignCurrentWordIndicatorOnResize();
};
const $7c44e9d4c9fe16e3$var$listenUnfocusTestInput = ()=>{
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).addEventListener("blur", ()=>{
        // prevent getting unfocused on window unfocus
        if (document.hasFocus()) (0, $f193b2ccc654ef47$export$e6a7208b0d9569e1)();
    });
};
const $7c44e9d4c9fe16e3$var$listenFocusTestInput = ()=>{
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).addEventListener("focus", (e)=>(0, $f193b2ccc654ef47$export$6699060e52d60aa1)(e));
};
const $7c44e9d4c9fe16e3$var$listenCompleteWord = ()=>{
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).addEventListener("keydown", (e)=>{
        if ((0, $a1848bf1cadb8d5f$export$44487a86467333c3)().currentWordIndicatorAnimations === "on" && e.key !== "Backspace") {
            (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).style.scale = "1.20";
            setTimeout(()=>{
                (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).style.scale = "1.00";
            }, 50);
        }
        if (e.key === " " && (0, $78239f00f1dce5ee$export$d533be0028bf978d)() === "in-progress") {
            e.preventDefault();
            let wordIndex = (0, $a2db21f4cb59e11c$export$e710b52d623a71ad)();
            const wordSpanEl = document.getElementById(`w-${wordIndex}`);
            if ((0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).value === wordSpanEl.textContent) {
                const totalWords = (0, $a1848bf1cadb8d5f$export$44487a86467333c3)().testInfo.words;
                const isLastWord = wordIndex === totalWords;
                wordSpanEl.classList.add("text-emerald-500");
                (0, $a2db21f4cb59e11c$export$e6bc8450ad81a778)((0, $a2db21f4cb59e11c$export$a3d08e7102597923)() + wordSpanEl.textContent.length + (isLastWord ? 0 : 1));
                wordIndex += 1;
                (0, $a2db21f4cb59e11c$export$1f1f6014d63e98f6)(wordIndex);
                if (isLastWord) (0, $3948815c2aaf0381$export$1087492337de9603)();
                else {
                    const currWordSpanEl = document.getElementById(`w-${wordIndex}`);
                    (0, $2b5f46016294fb27$export$b3353b67a6a0770d)();
                    const movedDown = (0, $2b5f46016294fb27$export$20cc271121bbde84)(currWordSpanEl);
                    if (wordIndex !== 1 && movedDown) {
                        const prevWordSpanEls = Array.from((0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).querySelectorAll("span"));
                        for (const span of prevWordSpanEls){
                            if (span === currWordSpanEl) break;
                            span.remove();
                        }
                        (0, $2b5f46016294fb27$export$20cc271121bbde84)(currWordSpanEl);
                    }
                    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).value = "";
                }
            }
        }
    });
};
const $7c44e9d4c9fe16e3$var$listenCharInput = ()=>{
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).addEventListener("input", ()=>{
        const wordIndex = (0, $a2db21f4cb59e11c$export$e710b52d623a71ad)();
        const wordSpanEl = document.getElementById(`w-${wordIndex}`);
        // user starts typing
        if (wordIndex === 0 && (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).value.length === 1) {
            (0, $a2db21f4cb59e11c$export$bd6cde7132e04046)(Date.now());
            if ((0, $78239f00f1dce5ee$export$d533be0028bf978d)() === "not-started") {
                (0, $36749efec06aa61f$export$5985f5b4428bec55)();
                (0, $78239f00f1dce5ee$export$41f3a0a73bb8b261)("in-progress");
            }
        }
        const correctSoFar = wordSpanEl.textContent?.startsWith((0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).value);
        if (!correctSoFar) (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).classList.replace("bg-neutral-500", "bg-rose-500");
        else (0, $1bc98ea51c43dc5c$export$1068e950eff93f20).classList.replace("bg-rose-500", "bg-neutral-500");
        const totalWords = (0, $a1848bf1cadb8d5f$export$44487a86467333c3)().testInfo.words;
        const isLastWord = wordIndex === totalWords - 1;
        if (isLastWord && (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).value === wordSpanEl.textContent) {
            (0, $a2db21f4cb59e11c$export$e6bc8450ad81a778)((0, $a2db21f4cb59e11c$export$a3d08e7102597923)() + wordSpanEl.textContent.length + (isLastWord ? 0 : 1));
            (0, $3948815c2aaf0381$export$1087492337de9603)();
        }
    });
};
const $7c44e9d4c9fe16e3$export$68dcec276bb0168 = ()=>{
    document.addEventListener("keydown", (e)=>{
        if (e.key === " ") (0, $f193b2ccc654ef47$export$12d9e5f9858e8e8c)(e);
        if (e.key === "Escape") {
            (0, $f193b2ccc654ef47$export$e6a7208b0d9569e1)();
            (0, $48b5dc5f019e67f5$export$bd1b731c4bf61afb)();
        }
        if (e.key === "Tab") (0, $48b5dc5f019e67f5$export$a94b587a1cc82520)(e);
    });
};
const $7c44e9d4c9fe16e3$var$realignCurrentWordIndicatorOnResize = ()=>{
    let resizeTimeout;
    window.addEventListener("resize", ()=>{
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(()=>{
            const wordIndex = (0, $a2db21f4cb59e11c$export$e710b52d623a71ad)();
            const wordSpanEl = document.getElementById(`w-${wordIndex}`);
            (0, $2b5f46016294fb27$export$20cc271121bbde84)(wordSpanEl);
        }, 250);
    });
};





const $275dc46f24e35dff$export$49dba9a654dfd39 = (config)=>{
    if (config.testInfo.type === "words") (0, $1bc98ea51c43dc5c$export$fc31c273664452ca).click();
    if (config.testInfo.words === 10) (0, $1bc98ea51c43dc5c$export$f01f3933c59ae7c1).click();
    else if (config.testInfo.words === 25) (0, $1bc98ea51c43dc5c$export$a159b208d2279103).click();
    else if (config.testInfo.words === 50) (0, $1bc98ea51c43dc5c$export$8137a8da3720eff5).click();
    else if (config.testInfo.words === 100) (0, $1bc98ea51c43dc5c$export$daf244641a671a33).click();
    else if (config.testInfo.words === 200) (0, $1bc98ea51c43dc5c$export$5e12fee2da7f30a).click();
    if (config.currentWordIndicatorAnimations === "on") (0, $1bc98ea51c43dc5c$export$d3fad732915680bc).click();
    else if (config.currentWordIndicatorAnimations === "off") (0, $1bc98ea51c43dc5c$export$41b57f6f5001a03).click();
};



const $1555327a3df13043$export$3ce035463dc56fe0 = (buttons, attr)=>{
    buttons.forEach((btn)=>{
        buttons.forEach((btn)=>{
            btn.setAttribute(`btn-option-type`, attr);
            btn.setAttribute("selected", "no");
            btn.classList.remove("bg-blue-500/20");
        });
        btn.onclick = ()=>{
            // disable other buttons
            buttons.forEach((btn)=>{
                btn.setAttribute("selected", "no");
                btn.classList.remove("bg-blue-500/20");
            });
            btn.classList.add("bg-blue-500/20");
            btn.setAttribute("selected", "yes");
        };
    });
};


const $fa3cac46300795ec$export$8fb72acc2e187b3e = ()=>{
    $fa3cac46300795ec$export$a9efc12df15a95d.forEach((btnSwitch)=>(0, $1555327a3df13043$export$3ce035463dc56fe0)(btnSwitch.buttons, btnSwitch.attr));
};
const $fa3cac46300795ec$export$a9efc12df15a95d = [
    {
        buttons: [
            (0, $1bc98ea51c43dc5c$export$fc31c273664452ca)
        ],
        attr: "options-test-type"
    },
    {
        buttons: [
            (0, $1bc98ea51c43dc5c$export$f01f3933c59ae7c1),
            (0, $1bc98ea51c43dc5c$export$a159b208d2279103),
            (0, $1bc98ea51c43dc5c$export$8137a8da3720eff5),
            (0, $1bc98ea51c43dc5c$export$daf244641a671a33),
            (0, $1bc98ea51c43dc5c$export$5e12fee2da7f30a)
        ],
        attr: "options-words"
    },
    {
        buttons: [
            (0, $1bc98ea51c43dc5c$export$d3fad732915680bc),
            (0, $1bc98ea51c43dc5c$export$41b57f6f5001a03)
        ],
        attr: "options-current-word-indicator-animations"
    }
];



const $402b00af7be6fc0d$export$6de20931fb065784 = (obj, modifier)=>{
    const draft = {
        ...obj
    };
    modifier(draft);
    return draft;
};


const $b2ea756a79fd5afa$export$40d447ca100bbe40 = ()=>{
    const draft = (0, $402b00af7be6fc0d$export$6de20931fb065784)((0, $a1848bf1cadb8d5f$export$44487a86467333c3)(), (draft)=>{
        const selectedTestType = document.querySelector(`button[btn-option-type="options-test-type"][selected="yes"]`);
        const selectedWords = document.querySelector(`button[btn-option-type="options-words"][selected="yes"]`);
        const selectedCurrentWordIndicatorAnimations = document.querySelector(`button[btn-option-type="options-current-word-indicator-animations"][selected="yes"]`);
        if (selectedTestType.id === "options-test-type-words-button") draft.testInfo.type = "words";
        if (selectedWords.id === "options-words-10-button") draft.testInfo.words = 10;
        else if (selectedWords.id === "options-words-25-button") draft.testInfo.words = 25;
        else if (selectedWords.id === "options-words-50-button") draft.testInfo.words = 50;
        else if (selectedWords.id === "options-words-100-button") draft.testInfo.words = 100;
        else if (selectedWords.id === "options-words-200-button") draft.testInfo.words = 200;
        if (selectedCurrentWordIndicatorAnimations.id === "options-current-word-indicator-animations-on-button") draft.currentWordIndicatorAnimations = "on";
        else if (selectedCurrentWordIndicatorAnimations.id === "options-current-word-indicator-animations-off-button") draft.currentWordIndicatorAnimations = "off";
    });
    (0, $a1848bf1cadb8d5f$export$940a7873bb071df8)(draft);
};











const $4e4c3942c1687d84$export$98cb916552ec6ef6 = (id, css)=>{
    document.querySelector(`style[css-id="${id}"]`)?.remove();
    const styleEl = document.createElement("style");
    styleEl.setAttribute("css-id", id);
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
};
const $4e4c3942c1687d84$export$2232e336aecaa80a = (id)=>{
    document.querySelector(`style[css-id="${id}"]`)?.remove();
};



var $2fd6ebd9f1624a3c$export$2e2bcd8739ae039 = {
    name: "english",
    words: [
        "the",
        "be",
        "of",
        "and",
        "a",
        "to",
        "in",
        "he",
        "have",
        "it",
        "that",
        "for",
        "they",
        "I",
        "with",
        "as",
        "not",
        "on",
        "she",
        "at",
        "by",
        "this",
        "we",
        "you",
        "do",
        "but",
        "from",
        "or",
        "which",
        "one",
        "would",
        "all",
        "will",
        "there",
        "say",
        "who",
        "make",
        "when",
        "can",
        "more",
        "if",
        "no",
        "man",
        "out",
        "other",
        "so",
        "what",
        "time",
        "up",
        "go",
        "about",
        "than",
        "into",
        "could",
        "state",
        "only",
        "new",
        "year",
        "some",
        "take",
        "come",
        "these",
        "know",
        "see",
        "use",
        "get",
        "like",
        "then",
        "first",
        "any",
        "work",
        "now",
        "may",
        "such",
        "give",
        "over",
        "think",
        "most",
        "even",
        "find",
        "day",
        "also",
        "after",
        "way",
        "many",
        "must",
        "look",
        "before",
        "great",
        "back",
        "through",
        "long",
        "where",
        "much",
        "should",
        "well",
        "people",
        "down",
        "own",
        "just",
        "because",
        "good",
        "each",
        "those",
        "feel",
        "seem",
        "how",
        "high",
        "too",
        "place",
        "little",
        "world",
        "very",
        "still",
        "nation",
        "hand",
        "old",
        "life",
        "tell",
        "write",
        "become",
        "here",
        "show",
        "house",
        "both",
        "between",
        "need",
        "mean",
        "call",
        "develop",
        "under",
        "last",
        "right",
        "move",
        "thing",
        "general",
        "school",
        "never",
        "same",
        "another",
        "begin",
        "while",
        "number",
        "part",
        "turn",
        "real",
        "leave",
        "might",
        "want",
        "point",
        "form",
        "off",
        "child",
        "few",
        "small",
        "since",
        "against",
        "ask",
        "late",
        "home",
        "interest",
        "large",
        "person",
        "end",
        "open",
        "public",
        "follow",
        "during",
        "present",
        "without",
        "again",
        "hold",
        "govern",
        "around",
        "possible",
        "head",
        "consider",
        "word",
        "program",
        "problem",
        "however",
        "lead",
        "system",
        "set",
        "order",
        "eye",
        "plan",
        "run",
        "keep",
        "face",
        "fact",
        "group",
        "play",
        "stand",
        "increase",
        "early",
        "course",
        "change",
        "help",
        "line"
    ]
};




const $d964b88191dc9588$export$a7de9326ee491b1d = ({ words: words })=>{
    (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).textContent = "";
    (0, $78239f00f1dce5ee$export$41f3a0a73bb8b261)("in-progress");
    for(let i = 0; i < words; i++){
        const word = (0, $2fd6ebd9f1624a3c$export$2e2bcd8739ae039).words[Math.floor(Math.random() * (0, $2fd6ebd9f1624a3c$export$2e2bcd8739ae039).words.length)];
        const span = document.createElement("span");
        span.id = `w-${i}`;
        span.style.zIndex = "100";
        span.textContent = word;
        (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).appendChild(span);
        if (i !== words - 1) (0, $1bc98ea51c43dc5c$export$50b5fc66fb330b94).appendChild(document.createTextNode(" "));
    }
};



const $c96f9147e53a4026$export$e796ea6ff31dcdbc = ()=>{
    const config = (0, $a1848bf1cadb8d5f$export$44487a86467333c3)();
    if (config.currentWordIndicatorAnimations === "on") (0, $4e4c3942c1687d84$export$98cb916552ec6ef6)("indicator-styles", ".indicator-animation{transition:150ms cubic-bezier(0.25, 1.25, 0.5, 1);}");
    else if (config.currentWordIndicatorAnimations === "off") (0, $4e4c3942c1687d84$export$98cb916552ec6ef6)("indicator-styles", ".indicator-animation{transition:0s !important;}");
    (0, $a2db21f4cb59e11c$export$3e41cefc7a4774f7)(config.testInfo);
    (0, $d964b88191dc9588$export$a7de9326ee491b1d)(config.testInfo);
    (0, $a2db21f4cb59e11c$export$1f1f6014d63e98f6)(0);
    (0, $a2db21f4cb59e11c$export$e6bc8450ad81a778)(0);
    (0, $1bc98ea51c43dc5c$export$f23cc5db4e5d5a53).value = "";
    (0, $36749efec06aa61f$export$4d41f7386211339a)();
    (0, $36749efec06aa61f$export$148d61ea341bbff7)();
    (0, $36749efec06aa61f$export$18e1d7a642e396fa)();
    (0, $78239f00f1dce5ee$export$41f3a0a73bb8b261)("not-started");
    const testCardShown = (0, $1bc98ea51c43dc5c$export$1ae16fa4a9e4bff5).classList.contains("block");
    if (!testCardShown) (0, $586319c84bea0266$export$a6eec20204fcb27f)((0, $1bc98ea51c43dc5c$export$1ae16fa4a9e4bff5)).then(()=>{
        $c96f9147e53a4026$var$handleTestCardAlreadyShown();
    });
    else $c96f9147e53a4026$var$handleTestCardAlreadyShown();
};
const $c96f9147e53a4026$var$handleTestCardAlreadyShown = ()=>{
    const firstWordSpan = document.getElementById(`w-${0}`);
    (0, $2b5f46016294fb27$export$20cc271121bbde84)(firstWordSpan);
    (0, $2b5f46016294fb27$export$bbc511b76550a421)();
    (0, $2b5f46016294fb27$export$b3353b67a6a0770d)();
    (0, $f193b2ccc654ef47$export$12d9e5f9858e8e8c)();
};



const $8b2d8f78c9cb6d3e$export$d81753d667442476 = ()=>{
    (0, $2b5f46016294fb27$export$878e62d4407c63a6)();
    (0, $36749efec06aa61f$export$4d41f7386211339a)();
    (0, $36749efec06aa61f$export$148d61ea341bbff7)();
    (0, $586319c84bea0266$export$a6eec20204fcb27f)((0, $1bc98ea51c43dc5c$export$d32bf212a3195752));
};
const $8b2d8f78c9cb6d3e$export$1adab225c69b21f9 = ()=>{
    (0, $c96f9147e53a4026$export$e796ea6ff31dcdbc)();
};



const $742b112b4221a122$export$a2e58475e09a3523 = ()=>{
    const config = (0, $a1848bf1cadb8d5f$export$44487a86467333c3)();
    (0, $c96f9147e53a4026$export$e796ea6ff31dcdbc)();
    (0, $7c44e9d4c9fe16e3$export$7d66fdeae8af3f34)();
    (0, $1bc98ea51c43dc5c$export$9ab3e8ebbd54dd89).onclick = ()=>(0, $c96f9147e53a4026$export$e796ea6ff31dcdbc)();
    (0, $1bc98ea51c43dc5c$export$e8cb2ff66da92add).onclick = ()=>(0, $8b2d8f78c9cb6d3e$export$d81753d667442476)();
    (0, $1bc98ea51c43dc5c$export$f427401ec6aabe5d).onclick = ()=>{
        (0, $b2ea756a79fd5afa$export$40d447ca100bbe40)();
        (0, $8b2d8f78c9cb6d3e$export$1adab225c69b21f9)();
    };
    (0, $fa3cac46300795ec$export$8fb72acc2e187b3e)();
    (0, $275dc46f24e35dff$export$49dba9a654dfd39)(config);
};


(0, $742b112b4221a122$export$a2e58475e09a3523)();


//# sourceMappingURL=index.29b27aa2.js.map
